"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDrawerLayout = exports.DrawerLayoutContext = void 0;
var react_1 = require("react");
exports.DrawerLayoutContext = react_1.createContext({
    /* eslint-disable @typescript-eslint/no-unused-vars */
    setPadding: function (padding) { return null; },
    setDrawerOpen: function (open) { return false; },
    /* eslint-enable @typescript-eslint/no-unused-vars */
});
var useDrawerLayout = function () {
    var context = react_1.useContext(exports.DrawerLayoutContext);
    return context;
};
exports.useDrawerLayout = useDrawerLayout;
